const features = [
  {
    icon: 'ri-shield-check-line',
    title: '高清画质保障',
    desc: '全站采用超清视频编码技术，支持1080P及以上分辨率在线观看，画质细腻不模糊，为您呈现影院级视觉体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅播放体验',
    desc: '搭载智能CDN加速与自适应码率技术，根据网络环境自动优化播放质量，告别卡顿缓冲，畅享丝滑观影。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日资源更新',
    desc: '专业内容团队全天候运营，每日精选最新91高清视频在线资源准时上新，热门内容永不错过。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台优势
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            用心打造极致91国产高清视频观看体验，从画质到流畅度，每一个细节都力求完美
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-primary-500 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}